<template>
  <div class="bg-white rounded-lg border border-gray-200 p-6">
    <!-- Title và Description -->
    <div class="mb-6">
      <h3 class="text-lg font-medium text-slate-900">
        {{ $t('BUSINESS_DATA.TITLE') }}
      </h3>
      <p class="text-sm text-gray-500 mt-1">
        {{ $t('BUSINESS_DATA.DESCRIPTION') }}
      </p>
    </div>
    
    <!-- Stats Grid -->
    <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
      <!-- Total FAQs -->
      <div class="stat-card">
        <div class="stat-icon bg-blue-100 text-blue-600">
          <fluent-icon icon="chat-help" size="20" />
        </div>
        <div class="stat-content">
          <p class="stat-value">{{ stats.totalFaqs }}</p>
          <p class="stat-label">{{ $t('BUSINESS_DATA.STATS.TOTAL_FAQS') }}</p>
        </div>
      </div>
      
      <!-- Active FAQs -->
      <div class="stat-card">
        <div class="stat-icon bg-green-100 text-green-600">
          <fluent-icon icon="checkmark-circle" size="20" />
        </div>
        <div class="stat-content">
          <p class="stat-value">{{ stats.activeFaqs }}</p>
          <p class="stat-label">{{ $t('BUSINESS_DATA.STATS.ACTIVE_FAQS') }}</p>
        </div>
      </div>
      
      <!-- Total Data Items -->
      <div class="stat-card">
        <div class="stat-icon bg-purple-100 text-purple-600">
          <fluent-icon icon="document" size="20" />
        </div>
        <div class="stat-content">
          <p class="stat-value">{{ stats.totalDataItems }}</p>
          <p class="stat-label">{{ $t('BUSINESS_DATA.STATS.TOTAL_ITEMS') }}</p>
        </div>
      </div>
      
      <!-- Active Data Items -->
      <div class="stat-card">
        <div class="stat-icon bg-orange-100 text-orange-600">
          <fluent-icon icon="star-emphasis" size="20" />
        </div>
        <div class="stat-content">
          <p class="stat-value">{{ stats.activeDataItems }}</p>
          <p class="stat-label">{{ $t('BUSINESS_DATA.STATS.ACTIVE_ITEMS') }}</p>
        </div>
      </div>
    </div>
    
    <!-- Quick Actions -->
    <div class="mt-6 pt-6 border-t border-gray-200">
      <div class="flex flex-wrap gap-3">
        <woot-button
          color-scheme="primary"
          @click="$emit('add-faq')"
        >
          <fluent-icon icon="add" size="16" class="mr-2" />
          {{ $t('BUSINESS_DATA.ACTIONS.ADD_FAQ') }}
        </woot-button>
        
        <woot-button
          color-scheme="secondary"
          @click="$emit('add-data-item')"
        >
          <fluent-icon icon="document" size="16" class="mr-2" />
          {{ $t('BUSINESS_DATA.ACTIONS.ADD_ITEM') }}
        </woot-button>
        
        <woot-button
          variant="clear"
          @click="$emit('refresh')"
        >
          <fluent-icon icon="arrow-clockwise" size="16" class="mr-2" />
          {{ $t('BUSINESS_DATA.ACTIONS.REFRESH') }}
        </woot-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BusinessDataHeader',
  
  props: {
    stats: {
      type: Object,
      required: true,
      default: () => ({
        totalFaqs: 0,
        totalDataItems: 0,
        activeFaqs: 0,
        activeDataItems: 0,
      })
    }
  },
  
  emits: ['add-faq', 'add-data-item', 'refresh']
};
</script>

<style lang="scss" scoped>
.stat-card {
  @apply flex items-center p-4 bg-slate-100 rounded-lg;
  
  .stat-icon {
    @apply w-10 h-10 rounded-lg flex items-center justify-center mr-3;
  }
  
  .stat-content {
    .stat-value {
      @apply text-2xl font-bold text-slate-900;
    }
    
    .stat-label {
      @apply text-sm text-slate-500;
    }
  }
}

@media (max-width: 768px) {
  .stat-card {
    @apply flex-col text-center;
    
    .stat-icon {
      @apply mr-0 mb-2;
    }
  }
}
</style>
